import { render, staticRenderFns } from "./ProductPostingEditor.vue?vue&type=template&id=03281486&scoped=true"
import script from "./ProductPostingEditor.vue?vue&type=script&lang=js"
export * from "./ProductPostingEditor.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./ProductPostingEditor.vue?vue&type=style&index=1&id=03281486&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03281486",
  null
  
)

export default component.exports